function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  margin-left: 0.5625rem;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n\n  & > ", " {\n    margin-left: 0.5625rem;\n  }\n\n  ", " {\n    margin-top: 0.5rem;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  cursor: pointer;\n  align-items: center;\n  border-radius: 11px;\n  border: 1px solid ", ";\n  text-transform: uppercase;\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: 1.83;\n  padding: 0 0.25rem;\n  margin-left: 0;\n\n  ", " {\n    margin-left: 0.75rem;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  font-family: ", ";\n\n  ", " {\n    flex-direction: row;\n    align-items: center;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 0 4px 0;\n  font-family: ", ";\n  font-weight: ", ";\n  font-size: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import { AppIconStyle } from "../appIcon/AppIcon.styles";
import styled, { from, to } from "../../theme";
import { MessageCounter } from "./messageCounter/MessageCounter";
export var UserDropdownWrapper = styled.div(_templateObject());
export var UserName = styled.p(_templateObject2(), function (props) {
  return props.theme.variables.typography.secondaryFont;
}, function (props) {
  return props.theme.variables.fonts.weight.medium;
}, function (props) {
  return props.theme.variables.fonts.size.smaller1;
});
export var UserDropdownTools = styled.div(_templateObject3(), function (props) {
  return props.theme.variables.typography.primaryFont;
}, from('vlg'));
export var RateField = styled.div(_templateObject4(), function (props) {
  return props.theme.variables.colors.black;
}, function (props) {
  return props.theme.variables.fonts.size.smaller1;
}, function (props) {
  return props.theme.variables.fonts.weight.regular;
}, from('vlg'));
export var UserDropdownButtons = styled.div(_templateObject5(), AppIconStyle, to('vlg'));
export var StyledMessageCounter = styled(MessageCounter)(_templateObject6());